import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function News() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Stay updated on airport news and travel information with First-Class.com. Discover insights and tips for a seamless airport experience'
          }
        />
        <title>Airport News: Stay Informed on Airport News</title>
      </Head>
      <ArticlesList subtype="News" type="Airports" />
    </>
  );
}

export default withLayout(News, true);
